import './index.scss';
import React, { useEffect, useRef } from 'react';
import PDFViewer from '~/components/pdf_viewer';
import { isNumber } from '~/lib/math';
const DocView = ({ document, bookmarks }) => {
    const webViewerRef = useRef();
    const highlights = bookmarks ? bookmarks.flatMap(b => b.annotations) : [];
    useEffect(() => {
        if (!webViewerRef.current)
            return;
        const { annotationManager, Annotations, documentViewer } = webViewerRef.current.Core;
        const oldAnnots = annotationManager.getAnnotationsList();
        annotationManager.deleteAnnotations(oldAnnots.filter(a => a.Subject === 'Free Text'), { force: true });
        if (highlights.length === 0)
            return;
        const highlight = highlights[0];
        if (!isNumber(highlight.confidenceScore))
            return;
        const { x1: rgx1, y1: rgy1, x2: rgx2 } = highlight.coordinates;
        const { pageNum: pageNumber } = highlight;
        const pageWidth = Math.floor(documentViewer.getPageWidth(pageNumber));
        const pageHeight = Math.floor(documentViewer.getPageHeight(pageNumber));
        const x1 = Math.floor(rgx1 * pageWidth);
        const y1 = Math.floor(rgy1 * pageHeight);
        const x2 = Math.floor(rgx2 * pageWidth);
        const anno = new Annotations.FreeTextAnnotation(Annotations.FreeTextAnnotation.Intent.FreeText, {
            PageNumber: pageNumber,
            X: x1 + 180 > pageWidth ? x2 - 180 : x1,
            Y: y1 - 30,
            Width: 180,
            Height: 30,
            FontSize: '13px',
            TextAlign: 'center',
            TextVerticalAlign: 'bottom',
            TextColor: new Annotations.Color(0, 0, 255, 1),
            StrokeColor: new Annotations.Color(0, 0, 0, 0.6),
            FillColor: new Annotations.Color(255, 255, 255),
            selectionModel: undefined,
        });
        anno.setContents('Confidence Score: ' + highlight.confidenceScore + '%');
        annotationManager.addAnnotation(anno);
        annotationManager.drawAnnotations({ pageNumber });
    }, [bookmarks]);
    return (React.createElement(PDFViewer, { document: document.blob, highlights: bookmarks ? bookmarks.flatMap(b => b.annotations) : [], webViewerRef: webViewerRef }));
};
export default DocView;
